import { openAtcNotice } from '../sections/atc'

function ShowForm() {
  if ($('select[data-variant-selector]').length) {
    $('.oos-div-product').addClass('hide');
    $('.oos-div-product').removeClass('flex');
    $('.oos-div').addClass('flex');
    $('.oos-div').removeClass('hide');
    if ($('select[data-variant-selector]').find('option:selected').attr('data-variant-quantity') <= 0 && $('select[data-variant-selector]').find('option:selected').attr('data-variant-management') == 'shopify' && $('select[data-variant-selector]').find('option:selected').attr('data-variant-inventory-policy') != 'continue') {
      $('.instock-div').addClass('hide');
      $('.instock-div').removeClass('flex');
      $('.oos-div').removeClass('hide');
      $('.oss-div').addClass('flex');
      $('#notify-me-wrapper').addClass('flex');
      $('#notify-me-wrapper').removeClass('hide');
    }
    else if ($('select[data-variant-selector]').find('option:selected').attr('data-variant-quantity') > 0) {
      $('#notify-me-wrapper').addClass('hide');
      $('#notify-me-wrapper').removeClass('flex');
      $('.oos-div').addClass('hide');
      $('.oos-div').removeClass('flex');
      $('.instock-div').removeClass('hide');
      $('.instock-div').addClass('flex');
    }
    else if ($('select[data-variant-selector]').find('option:selected').attr('data-variant-inventory-policy') == 'continue') {
      $('#notify-me-wrapper').addClass('hide');
      $('#notify-me-wrapper').removeClass('flex');
      $('.oos-div').addClass('hide');
      $('.oos-div').removeClass('flex');
      $('.instock-div').removeClass('hide');
      $('.instock-div').addClass('flex');
    }
    else {
      $('#notify-me-wrapper').addClass('hide');
      $('#notify-me-wrapper').removeClass('flex');
      $('.oos-div').addClass('hide');
      $('.oos-div').removeClass('flex');
      $('.instock-div').removeClass('hide');
      $('.instock-div').addClass('flex');
    }
    console.log($('select[data-variant-selector]').find('option:selected').attr('data-variant-inventory-policy'));
  }
  else {
    $('.oos-div-product').addClass('flex');
    $('.oos-div-product').removeClass('hide');
    $('.oos-div').addClass('hide');
    $('.oos-div').removeClass('flex');
  }
}

function handleBackInStock () {
  let product_id = $('.atc-btn').attr('data-product-id') * 1,
      email = $("#notify-me-wrapper input[type='email']").val(),
      variant_id = product_id;

  if(typeof variant_id == 'undefined') {
    variant_id = $('.swatch.selected').attr('data-variant-id') * 1
  }
  // debugger
  $.ajax({
    type: "POST",
    url: "https://a.klaviyo.com/onsite/components/back-in-stock/subscribe",
    data: {
        a: "Qic29k",
        email: email,
        variant: variant_id,
        product: product_id,
        platform: "shopify"
    },
    success: function(response){
        console.log(response)
        $(".back-in-stock__form .feedback").prepend(`<p class="accent-text">Thanks! We will notify you when this product becomes available!</p>`)
        $("#notify-me-wrapper").slideToggle()
    }
  })
}


function toggleGiftMsgField() {
  if ($('.gift-msg-container').hasClass('hidden')) {
    $('.gift-msg-container').removeClass('hidden')
  } else {
    $('.gift-msg-container').addClass('hidden')
  }
}

function handleGift () {
  let checked = $('#gift-wrap').attr('checked')
  toggleGiftMsgField()
  $('#gift-wrap').trigger("change")
  if(checked) {
    $('#gift-wrap').attr('checked', false)
    return;
  }
  $('#gift-wrap').attr('checked', true);
  return;
}

const init = () =>  {
  ShowForm();
  $('.slick-pdp').slick({infinite: true,
    speed: 300,
    slidesToShow: 1,
    adaptiveHeight: true,
    arrows: false,
    dots: true
  });

    let vexAtcBtns = document.querySelectorAll('[data-vex-atc]')
    let vexVariantSel = document.querySelectorAll('[data-vex-variant-sel]')
    if (vexAtcBtns) {
      for(let i = 0; i < vexAtcBtns.length; i++) {
        vexAtcBtns[i].addEventListener('click', function(e) {
          variantId = parseInt(this.getAttribute('data-variant-id'))
          CartJS.addItem(variantId)
        })
      }
    }
  if (vexVariantSel) {

      for(let i = 0; i < vexVariantSel.length; i++) {
        vexVariantSel[i].addEventListener('change', function(e) {
          let productId = this.getAttribute('data-product-id')
          console.log(productId)
          let atcBtn = document.querySelectorAll('button[data-product-id="'+ productId +'"]')
          for(j = 0; j < atcBtn.length; j++) {
            atcBtn[j].setAttribute('data-variant-id', e.target.value)
          }
          console.log(atcBtn)
          console.log(e.target.value)
        })
      }

    }
  let giftMsg = document.querySelector('textarea[name="gift-message"]')
  if(giftMsg) {
    giftMsg.addEventListener('input', function() {
    let val = this.value
    let giftMsgCharCount = document.querySelector('span.gift-msg-char-count > span.current')
    giftMsgCharCount.innerText = val.length
  })
  }

  let inputs = document.querySelectorAll( 'input[type="file"]' );
  if (inputs) {
    inputs.forEach( input => {
      let label	 = input.nextElementSibling,
        labelVal = label.innerHTML,
        fileName;

      input.addEventListener( 'change', function( e )
      {
        fileName = e.target.value.split( "\\" ).pop();
        console.log(e.target.id)

        if( fileName )
          label.querySelector( 'span.file-selected' ).innerText = fileName;
      });
    });
  }

  $('input[name="return_to"]').attr('value', window.location.pathname+"?atc=true")

  $('select[data-variant-selector]').on('change', function() {
    $('.atc-btn').attr('data-product-id', $(this).find('option:selected').val())
    $('[data-product-price]').text($(this).find('option:selected').attr('data-variant-price'))
    ShowForm()
    if(!$(this).find('option:selected').attr('data-variant-img-url').includes('.gif')) {
      $('[data-featured-img]').attr('src', $(this).find('option:selected').attr('data-variant-img-url'))
      $(".slick-current > div > div > img").attr(
            "src",
            $(this).find('option:selected').attr('data-variant-img-url')
      );

    }

  })
  $('.gc-variant-selector__variant input').on('change', function(){
    var $sel = $(this).closest('section').find('.gc-variant-selector__variant input:checked');
    $(this).closest('section').find('#variant-selector').val($sel.val())[0].dispatchEvent(new Event('change'));
  })

  $('.desktop-carousel').flickity({
    // options
    wrapAround: false,
    contain: true,
    pageDots: false,
    fade: true,
    hash: true,
    prevNextButtons: false,
    imagesLoaded: true
  });
  $('.mobile-carousel').flickity({
    // options
    wrapAround: true,
    contain: true,
    pageDots: true,
    prevNextButtons: false,
    imagesLoaded: true
  });
  $(".home-products-carousel").slick({
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    adaptiveHeight: false,
    mobileFirst: true,
    dots: true,
    arrows: false,
    prevArrow:
    '<i class="fas fa-chevron-left slick-prev-new text-2xl text-enewton-gray-400"></i>',
    nextArrow:
    '<i class="fas fa-chevron-right slick-next-new text-2xl text-enewton-gray-400"></i>',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 4,
          arrows: true,
          dots: false
        }
      }
    ]
  });
  $('.slick-featured-desktop').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    centerMode: true,
    asNavFor: '.slick-thumb-desktop'
  })
  $('.slick-thumb-desktop').slick({
    vertical: true,
    verticalSwiping: true,
    slidesToShow: 4,
    centerMode: true,
    focusOnSelect: true,
    asNavFor: '.slick-featured-desktop'
  })
  for(let i = 1; i < 100; i++) {
    $('[data-product-quantity]').append(`<option value="${i}">${i}</option>`)
  }
  $('[data-product-description-title]').on('click', function() {
    $('[data-product-description-accordion-toggle]').toggleClass('fa-plus fa-minus')
    console.log('testing')
    $('[data-product-description]').toggleClass('hidden')
  })
  $('.atc-btn').on('click', function() {
    let variant_id = $('.swatch.selected').attr('data-variant-id')
    if(typeof variant_id == 'undefined') {
      variant_id = $('.atc-btn').attr('data-product-id')
    }
    let necklaceExtender = $('#necklace-upsell')
    console.log(variant_id)
    let qty = $('[data-product-quantity] option:selected').val()
    let giftWrap = $('[data-gift-wrapping]').prop('checked')
    let giftWrapMsg;
    if(document.querySelector('[data-giftwrap-message]') && document.querySelector('[data-giftwrap-message]').value) {
      giftWrapMsg = document.querySelector('[data-giftwrap-message]').value
    }
    let data = {
    }
    if(giftWrap) {
      data.giftWrap = true
      if(giftWrapMsg !== '') {
        data.giftMessage = giftWrapMsg
      }
    }
    console.log(variant_id, qty, data)
    CartJS.addItem(variant_id, qty, data, {
      "success": function(data, textStatus, jqXHR) {
        openAtcNotice(data, qty)
      }
    })

    if(necklaceExtender) {
      if(necklaceExtender.prop('checked')) {
        CartJS.addItem(necklaceExtender.attr('data-variant-id'), 1)
      }
    }
  });
  var giftWrapOptionCheckbox = document.querySelector('#gift-wrap')
  if (giftWrapOptionCheckbox) {
    giftWrapOptionCheckbox.addEventListener('click', function(e) {
      handleGift()
    })
  }

  // Back in Stock Form
  $(".back-in-stock__trigger").click(function(){
    $(".back-in-stock__wrapper").slideDown()
    $(".back-in-stock__trigger").hide()
  })

  $("#contact_form").on("submit", function(e) {
    e.preventDefault()
    handleBackInStock ()
  })
}



export default init
